module.exports = __webpack_public_path__ + "img/photon-formula.02f5d26c.png";